import { getPublicProfile } from '../../../api/users';
import type { PublicUser } from '../../../api/users';

export type { PublicUser };

const cache = new Map<string, PublicUser>();

export async function getProfile(id: string | null): Promise<PublicUser | null> {
  if (!id) return null;
  const hit = cache.get(id);
  if (hit) return hit;
  try {
    const p = await getPublicProfile(id);
    cache.set(id, p);
    return p;
  } catch {
    return null;
  }
}
